export default __webpack_public_path__ + "static/media/5image.7fab45dc.png";